var __jsx = React.createElement;
import React, { useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { mediaQueries } from 'shared/styles';
import { DEFAULT_SPECIALS_CARD_IMG } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
import { useMediaQuery } from '@material-ui/core';
var LONG_DESCRIPTION_MIN_LENGTH_MOBILE = 85;
var LONG_DESCRIPTION_MIN_LENGTH = 213;
export default function IndividualBogoCard(_ref) {
  var displayImage = _ref.displayImage,
    displayName = _ref.displayName,
    displayDescription = _ref.displayDescription,
    _ref$showExpiredSpeci = _ref.showExpiredSpecial,
    showExpiredSpecial = _ref$showExpiredSpeci === void 0 ? false : _ref$showExpiredSpeci;
  var _useState = useState(false),
    showAllText = _useState[0],
    setShowAllText = _useState[1];
  var isMobile = useMediaQuery(mediaQueries.phone);
  var longDescriptionMinLength = isMobile ? LONG_DESCRIPTION_MIN_LENGTH_MOBILE : LONG_DESCRIPTION_MIN_LENGTH;
  var isLongDescription = (displayDescription === null || displayDescription === void 0 ? void 0 : displayDescription.length) >= longDescriptionMinLength;
  var defaultDescription = !isLongDescription ? displayDescription : _.truncate(displayDescription, {
    length: longDescriptionMinLength
  });
  function showHideDescription() {
    setShowAllText(function (prevShowAllText) {
      return !prevShowAllText;
    });
  }
  return __jsx(IndividualBogoCardContainer, {
    showExpiredSpecial: showExpiredSpecial
  }, __jsx(BackgroundImageContainer, {
    imageUrl: replaceAWSSourceWithImgix(displayImage) || DEFAULT_SPECIALS_CARD_IMG
  }), __jsx(IndividualBogoTextContainer, null, __jsx(IndividualBogoTitle, null, displayName), defaultDescription && __jsx(IndividualBogoDescription, null, showAllText ? displayDescription : defaultDescription, "\xA0", isLongDescription && __jsx(DescriptionExpanderLink, {
    onClick: showHideDescription
  }, showAllText ? 'Show less' : 'Show more'))));
}
var BackgroundImageContainer = styled.div.withConfig({
  displayName: "individual-bogo-card__BackgroundImageContainer",
  componentId: "sc-ci3orj-0"
})(["background-image:", ";background-position:center;background-size:cover;border-radius:", " 0 0 ", ";min-height:148px;position:absolute;top:0;left:0;bottom:0;right:43%;@media ", "{right:0;border-radius:", ";background-image:", ";}"], function (_ref2) {
  var imageUrl = _ref2.imageUrl;
  return "linear-gradient(90deg, rgba(11, 31, 50, 0.38) 0%, #0B1F32 100%), url(".concat(imageUrl, ")");
}, function (_ref3) {
  var _theme$customized$rad, _theme$customized, _theme$customized$rad2;
  var theme = _ref3.theme;
  return (_theme$customized$rad = theme === null || theme === void 0 ? void 0 : (_theme$customized = theme.customized) === null || _theme$customized === void 0 ? void 0 : (_theme$customized$rad2 = _theme$customized.radius) === null || _theme$customized$rad2 === void 0 ? void 0 : _theme$customized$rad2.lg) !== null && _theme$customized$rad !== void 0 ? _theme$customized$rad : '20px';
}, function (_ref4) {
  var _theme$customized$rad3, _theme$customized2, _theme$customized2$ra;
  var theme = _ref4.theme;
  return (_theme$customized$rad3 = theme === null || theme === void 0 ? void 0 : (_theme$customized2 = theme.customized) === null || _theme$customized2 === void 0 ? void 0 : (_theme$customized2$ra = _theme$customized2.radius) === null || _theme$customized2$ra === void 0 ? void 0 : _theme$customized2$ra.lg) !== null && _theme$customized$rad3 !== void 0 ? _theme$customized$rad3 : '20px';
}, mediaQueries.phone, function (_ref5) {
  var _theme$customized$rad4, _theme$customized3, _theme$customized3$ra;
  var theme = _ref5.theme;
  return (_theme$customized$rad4 = theme === null || theme === void 0 ? void 0 : (_theme$customized3 = theme.customized) === null || _theme$customized3 === void 0 ? void 0 : (_theme$customized3$ra = _theme$customized3.radius) === null || _theme$customized3$ra === void 0 ? void 0 : _theme$customized3$ra.lg) !== null && _theme$customized$rad4 !== void 0 ? _theme$customized$rad4 : '20px';
}, function (_ref6) {
  var imageUrl = _ref6.imageUrl;
  return "linear-gradient(180deg, rgba(11, 31, 50, 0.11) 0%, #0B1F32 66.59%), url(".concat(imageUrl, ")");
});
var DescriptionExpanderLink = styled.span.withConfig({
  displayName: "individual-bogo-card__DescriptionExpanderLink",
  componentId: "sc-ci3orj-1"
})(["cursor:pointer;display:inline;font-weight:bold;font-size:14px;line-height:175%;color:#0b99e6;white-space:nowrap;"]);
var IndividualBogoTextContainer = styled.div.withConfig({
  displayName: "individual-bogo-card__IndividualBogoTextContainer",
  componentId: "sc-ci3orj-2"
})(["z-index:200;"]);
var IndividualBogoDescription = styled.p.withConfig({
  displayName: "individual-bogo-card__IndividualBogoDescription",
  componentId: "sc-ci3orj-3"
})(["display:inline;font-size:13px;line-height:165%;color:#fff;word-break:break-word;"]);
var IndividualBogoTitle = styled.h3.withConfig({
  displayName: "individual-bogo-card__IndividualBogoTitle",
  componentId: "sc-ci3orj-4"
})(["font-weight:bold;font-size:20px;line-height:24px;color:#fff;margin-bottom:11px;word-break:break-word;"]);
var IndividualBogoCardContainer = styled.div.withConfig({
  displayName: "individual-bogo-card__IndividualBogoCardContainer",
  componentId: "sc-ci3orj-5"
})(["width:100%;min-height:148px;border-radius:", ";display:flex;padding:47px 55px;margin-bottom:55px;", " background-color:#0b1f32;position:relative;@media ", "{margin-bottom:20px;min-width:325px;min-height:179px;padding:70px 25px 25px;flex-direction:column;justify-content:center;}"], function (_ref7) {
  var _theme$customized$rad5, _theme$customized4, _theme$customized4$ra;
  var theme = _ref7.theme;
  return (_theme$customized$rad5 = theme === null || theme === void 0 ? void 0 : (_theme$customized4 = theme.customized) === null || _theme$customized4 === void 0 ? void 0 : (_theme$customized4$ra = _theme$customized4.radius) === null || _theme$customized4$ra === void 0 ? void 0 : _theme$customized4$ra.lg) !== null && _theme$customized$rad5 !== void 0 ? _theme$customized$rad5 : '20px';
}, function (props) {
  return props.showExpiredSpecial && "\n    filter: grayscale(80%) opacity(0.75);\n  ";
}, mediaQueries.phone);